@if (!allZeroData) {
  <div id="divChart" class="chart-container"
    [ngClass]="{ 'not-pre-registration': !isPreRegistration, 'pre-registration': isPreRegistration }">
    <canvas id="inPatientGender"> </canvas>
  </div>
}